import apiClient from 'services/_infra/apiClient';

export async function startService(name) {
  try {
    const res = await apiClient.post(`/service-manager/supervisor/start/${name}`);
    return res.data;
  } catch (err) {
    console.error(`Error starting service '${name}':`, err);
    throw err;
  }
}

export async function stopService(name) {
  try {
    const res = await apiClient.post(`/service-manager/supervisor/stop/${name}`);
    return res.data;
  } catch (err) {
    console.error(`Error stopping service '${name}':`, err);
    throw err;
  }
}

export async function restartService(name) {
  try {
    const res = await apiClient.post(`/service-manager/supervisor/restart/${name}`);
    return res.data;
  } catch (err) {
    console.error(`Error restarting service '${name}':`, err);
    throw err;
  }
}
